module.exports = __webpack_public_path__ + "img/nodata.3ab8324e.svg";